import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwap = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.10826 5.83984L17.0482 5.83984L15.0227 3.78613C14.5947 3.35221 14.5947 2.64778 15.0227 2.21386C15.4506 1.78025 16.1445 1.7803 16.5724 2.21386L20.4693 6.16504L20.5444 6.24902C20.8954 6.68536 20.8703 7.32951 20.4693 7.73633L16.5724 11.6865C16.1444 12.1204 15.4506 12.1204 15.0227 11.6865C14.5949 11.2526 14.5948 10.5491 15.0227 10.1152L17.0482 8.06152L4.10826 8.06152C3.50316 8.06138 3.01219 7.56375 3.01219 6.95019C3.01242 6.33682 3.50329 5.83998 4.10826 5.83984ZM19.694 15.7158C20.2992 15.7158 20.79 16.2135 20.79 16.8271C20.79 17.4408 20.2992 17.9385 19.694 17.9385H6.755L8.77954 19.9922C9.2075 20.4261 9.2075 21.1296 8.77954 21.5635C8.35157 21.9973 7.65774 21.9973 7.22983 21.5635L3.33388 17.6133C3.12837 17.4049 3.01219 17.1218 3.01219 16.8271C3.0122 16.5325 3.12838 16.2494 3.33388 16.041L7.22983 12.0908C7.65774 11.6569 8.35157 11.657 8.77954 12.0908C9.2075 12.5247 9.2075 13.2282 8.77954 13.6621L6.755 15.7158H19.694Z",
		fill: "currentColor"
	})
});
export default SvgSwap;
